module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 5